import { events } from "./events/index";

const { components } = require("./components/index");

const MRC1AttachmentsSection = {
  components,
  events
}

export { MRC1AttachmentsSection }